<template>
    <div>
        <!-- <b-row>
            <b-col>
                <div class="form-group">
                    <b-button v-if="isDist !== 0" size="sm" variant="primary" @click="boletosAntigos"><i
                            class="fas fa-history"></i> Boletos Antigos</b-button>
                </div>
            </b-col>
        </b-row> -->
        <div>
            <div v-if="usuarioInadimplente" class="alert alert-danger mt-4 mx-4" style="border: 1px solid red;">
                <strong>Atenção:</strong> você possui boletos em atraso.
                Regularize para realizar novos pedidos. 
                <p></p>
                Procure o Departamento de Cobranças para a regularização do boleto!   → 
                <strong>
                <a href="https://api.whatsapp.com/send?phone=556282800073&
                text=Ol%C3%A1!%20Vim%20pelo%20portal%20distribuidor%20Abelha%20Rainha,%20queria%20regularelizar%20meus%20debitos%20como%20proceder?">clique aqui</a> 
                    </strong>
            </div>
        </div>
        <b-row>
            <h3>Boletos</h3>
            <div class="col-md-2 text-end mb-2" style="color: #e66f85; align-content: space-evenly;">
                <i class="fas fa-question-circle"
                title="Boletos após vencimento de 60 dias. O distribuidor devera entrar em contato com departamento de cobranças"></i>
            </div>
        </b-row>
        <b-card>    
            <b-row align-v="end">
                <b-col class="col-md-2">
                    <label for="status">Status</label>
                    <b-form-select id="status" title="Status" label-field="Status" v-model="status"
                        :options="optionStatus" size="sm"></b-form-select>
                </b-col>
                <b-col class="col-md-2" v-if="isDist === 0">
                    <label for="distri">Distribuidor</label>
                    <b-form-input v-mask="['##########']" id="distri" title="Distribuidor" placeholder="Código"
                        @keyup.enter="loadBoletos()" v-model="distribuidor" size="sm"></b-form-input>
                </b-col>
                <b-col class="col-md-2" v-if="status != 'A'">
                    <label for="de">Vencimento De</label>
                    <b-form-datepicker id="de" placeholder="Nenhuma Data" calendar-width="200" label-no-date-selected=""
                        label-next-month="Próximo Mês" label-next-year="Próximo Ano" label-prev-month="Mês Anterior"
                        label-prev-year="Ano Anterior" label-current-month="Mês Atual" label-help hide-header
                        reset-button reset-button-variant="danger" label-reset-button="Limpar" size="sm"
                        v-model="dataDe" :date-format-options="{
                            year: 'numeric',
                            month: 'numeric',
                            day: 'numeric',
                        }" locale="pt-BR">
                    </b-form-datepicker>
                </b-col>

                <b-col class="col-md-2" v-if="status != 'A'">
                    <label for="ate">Até</label>
                    <b-form-datepicker id="ate" placeholder="Nenhuma Data" calendar-width="200"
                        label-no-date-selected="" label-next-month="Próximo Mês" label-next-year="Próximo Ano"
                        label-prev-month="Mês Anterior" label-prev-year="Ano Anterior" label-current-month="Mês Atual"
                        label-help hide-header reset-button reset-button-variant="danger" label-reset-button="Limpar"
                        size="sm" v-model="dataAte" :date-format-options="{
                            year: 'numeric',
                            month: 'numeric',
                            day: 'numeric',
                        }" locale="pt-BR">
                    </b-form-datepicker>
                </b-col>             
                <b-col>
                    <b-button class="mt-4" size="sm" variant="primary" @click="loadBoletos()"
                        :disabled="loadingBoletos || loading"><i class="fas fa-search"></i>
                        Buscar</b-button>
                </b-col>
            </b-row>
            <b-row v-if="boletos.length > 0 && isDist === 0" class="mt-3">
                <b-col>
                    <h5 class="text-primary"> {{ distribuidorBusca }} </h5>
                </b-col>
            </b-row>
            <b-row class="mt-3">
                <b-col>
                    <b-overlay :show="loading" rounded="sm">
                        <b-table :items="boletos" :fields="showHeader" :busy="loadingBoletos" :current-page="pageBoleto"
                            :per-page="perPage" :sort-by.sync="sortBy" :sort-desc.sync="sortDesc"
                            :sort-direction="sortDirection" stacked="md" show-empty small>
                            <template #table-busy>
                                <div class="text-center text-danger my-2">
                                    <b-spinner class="align-middle"></b-spinner>
                                    <strong>Carregando ..</strong>
                                </div>
                            </template>
                            <template #empty>
                                <h4>Nenhum Boleto Encontrado!</h4>
                            </template>
                            <template #cell(id)="row">
                                <b-button size="sm" :variant="row.item.STATUS == 'BAIXADO' ? 'primary' : 'danger'"
                                    title="Gerar Boleto" @click="gerarBoleto(row.item)">
                                    <i class="fas fa-file-pdf"></i>
                                </b-button>
                                <!-- <b-button size="sm" variant="danger" title="Gerar Boleto" v-else @click="gerarBoleto(row.item)"><i class="fas fa-file-pdf"></i></b-button>                                 -->
                            </template>
                        </b-table>
                        <b-pagination v-if="boletos.length > 18" v-model="pageBoleto" :total-rows="totalRows"
                            :per-page="perPage" align="fill" size="sm" class="my-0"></b-pagination>
                    </b-overlay>
                </b-col>
            </b-row>
        </b-card>
    </div>
</template>

<script>
import { icon } from 'leaflet';
export default {
    data() {
        return {
            loading: false,
            datePickerConfig: {
                format: "DD/MM/YYYY",
                showClose: true,
            },
            fields: [{
                label: "Status",
                key: "STATUS",
                sortable: true
            },
            {
                label: "Fatura",
                key: "NUNDOC",
                sortable: true
            },

            {
                label: "Emissão",
                key: "EMISSAO",
                formatter: (value) => {
                    return moment(value).format('DD/MM/YY')
                },
                sortable: true,
            },
            {
                label: "Vencimento",
                key: "VENCREA",
                formatter: (value) => {
                    return moment(value).format('DD/MM/YY')
                },
                sortable: true,
            },
            {
                label: "Valor",
                key: "VALORTOTAL",
                sortable: true,
                formatter: (value) => {
                    return parseFloat(value).toFixed(2).toString().replace('.', ',')
                },
            },
            {
                label: "Dt Baixa",
                key: "BAIXA",
                formatter: (value) => {
                    if (value) {
                        return moment(value).format('DD/MM/YY')
                    }
                },
                sortable: true,
            },
            {
                label: "Boleto",
                key: "id",
            },

            ],
            optionStatus: [
                {
                    value: 'A',
                    text: "Abertos"
                },
                {
                    value: 'B',
                    text: "Baixados"
                }
            ],
            pageBoleto: 1,
            loadingBoletos: false,
            totalRows: 1,
            perPage: 20,
            sortBy: "VENCREA",
            sortDesc: false,
            sortDirection: "asc",
            status: "A",
            distribuidor: "",
            boletos: [],
            isDist: parseInt($("#isDistribuidor").val()),
            formatted: "",
            loadingBoleto: false,
            dataDe: '',
            dataAte: '',
            distribuidorBusca: '',
            usuarioInadimplente: false,
        };
    },
    methods: {
        boletosAntigos() {
            window.location.href = "/distribuidor/boletos-antigos";
        },

        gerarBoleto(data) {
            const vm = this;
            this.loadingBoleto = true;
            let dados = data;
            const params = {
                boleto: JSON.stringify(dados),
                tipo: 'boleto'
            }
            this.loading = true;
            axios.get('/get-link', { params: params })
                .then((response) => {
                    window.open('/boleto/gerar/' + response.data.resource, '_blank');
                }).catch((error) => {
                    console.log(error);
                    return vm.$swal({
                        icon: 'error',
                        title: 'Erro ao gerar boleto',
                    });
                }).finally(() => {
                    vm.loading = false
                })
            // axios
            //     .post("/boleto/gerar", { boleto: JSON.stringify(dados) })                
            //     .then(function(resp){
            //         //console.log(resp.data);
            //         if(resp.data == 'Dados inválidos') {
            //         return vm.$swal(
            //             "Dados inválidos para este boleto",
            //             "Carteira inválida",
            //             "error"
            //             );
            //         }

            //         var openBoleto = window.open("","_blank");       
            //         let objBoleto = resp.data.boleto;
            //         let html = '';
            //         html += '<html>';                   
            //         html += '<title>'+ data.NUNDOC +'</title>';
            //         html += '<body style="margin:0!important">';
            //         html += '<embed width="100%" height="100%" src= "data:application/pdf;base64,'+ objBoleto +'" type="application/pdf" />';
            //         //html += '<embed width="100%" height="100%" src="data:application/pdf;base64,'+ objBoleto +'" />';
            //         html += '</body>';
            //         html += '</html>';
            //         openBoleto.document.write(html);                   
            //         //openBoleto.document.write(html);
            //     })
            //     .catch(function (error) {
            //         console.log(error);                    
            //         return vm.$swal(
            //             "Erro ao gerar boleto!",
            //             error.message,
            //             "error"
            //         );   
            //     });
        },

        loadBoletos() {
            const vm = this;
            vm.boletos = [];
            vm.usuarioInadimplente = false;
            if (vm.isDist === 0 && vm.distribuidor == '') {
                return vm.$swal({
                    title: "Digite o código do distribuidor!",
                    icon: 'info',
                    focusConfirm: true,
                    confirmButtonText: 'Ok',
                });
            }
            if ((vm.dataDe && vm.dataAte) && (vm.dataDe > vm.dataAte)) {
                return vm.$swal({
                    title: "A data vencimento de, deve ser menor que a data vencimento até!",
                    icon: 'info',
                    focusConfirm: true,
                    confirmButtonText: 'Ok',
                });
            }
            if (vm.status === 'A') {
                vm.dataAte = '';
                vm.dataDe = '';
            }

            let data = {
                from: vm.dataDe ? vm.dataDe : '',
                to: vm.dataAte ? vm.dataAte : '',
                novo: true,
                status: vm.status,
                distribuidor: vm.distribuidor ? vm.distribuidor : null,
            };
            vm.loadingBoletos = true;
            axios
                .get("/boleto/list", { params: data })
                .then((response) => {
                    //console.log(response.data)
                    vm.sortDesc = vm.status == 'A' ? false : true;
                    let BOLETOS = [];
                    if (response.data.Boleto) {
                        BOLETOS = response.data.Boleto;
                    } else {
                        BOLETOS = response.data;
                    }
                    // marcar inadimplência se backend enviar a flag ou se algum boleto indicar distribuidor_status_id === 3
                    if (response.data && response.data.usuario_inadimplente === true) {
                        vm.usuarioInadimplente = true;
                    } else if (BOLETOS && BOLETOS.some(item => item.distribuidor_status_id === 3)) {
                        vm.usuarioInadimplente = true;
                    }
                    if (BOLETOS) {
                        vm.distribuidorBusca = BOLETOS.length > 0 ? BOLETOS[0].CLIENTE + ' - ' + BOLETOS[0].NOME : '';
                        BOLETOS.forEach(el => {
                            el.STATUS = el.STATUS == 'A' ? 'ABERTO' : 'BAIXADO';
                            el.BAIXA = typeof el.BAIXA === 'string' ? vm.formataData(el.BAIXA) : '';
                            el.EMISSAO = vm.formataData(el.EMISSAO);
                            el.VENCREA = vm.formataData(el.VENCREA);
                        });

                        vm.boletos = BOLETOS;
                        vm.totalRows = vm.boletos.length;
                    }
                    vm.pageBoleto = 1;
                    vm.loadingBoletos = false;
                    $(".loading").hide();
                })
                .catch((error) => {
                    $(".loading").hide();
                    vm.loadingBoletos = false;
                    console.log(error);
                    if (error.response.status === 422) {
                        return vm.$swal({
                            icon: 'error',
                            title: error.response.data.errors,
                        });
                        //return alert(error.response.data.errors );
                    }
                    alert("Erro ao carregar os boletos.");
                });
        },
        formataData(data) {
            let date = moment(data).format("YYYY-MM-DD");
            return date;
        },
    },
    mounted() {
        if (this.isDist !== 0) {
            this.loadBoletos();
        }
    },
    created() {

    },
    computed: {
        showHeader() {
            return this.fields;
        },
    },
};
</script>

<style scoped>
.btn-search {
    margin-top: 25px;
}
</style>



// WEBPACK FOOTER //
// resources/assets/js/components/boleto/Main.vue